import { BUTTON_SIZE, DSButton } from '@repo/design-system/index'
import { COLORS } from '../../../../modules/vars'

const BlogDetailMobileCTASection = ({ ctaList, title }) => {
  const stringData = `<div>${title.replace(/\\n/g, '<br />')}</div>`

  const isExternalLink = (link) => link?.includes('https://')

  return (
    <div className={style.snsVideoSectionLayout}>
      <hr />
      <div className={style.snsVideoSectionTitle}>
        <div dangerouslySetInnerHTML={{ __html: stringData }} />
      </div>
      <div className={style.snsVideoSectionButton}>
        {ctaList.map((buttonItem, i) => (
          <a
            key={i}
            href={buttonItem.link}
            target={isExternalLink(buttonItem.link) ? '_blank' : '_self'}
            rel="noreferrer"
          >
            <DSButton size={BUTTON_SIZE.MD} customBgColor={COLORS.PURPLE100} onClick={() => console.log('')}>
              <DSButton.Label customTxtColor={COLORS.PURPLE500}>{buttonItem.title}</DSButton.Label>
            </DSButton>
          </a>
        ))}
      </div>
    </div>
  )
}

export default BlogDetailMobileCTASection

const style = {
  snsVideoSectionLayout: `mt-[40px] px-[16px]`,
  snsVideoSectionTitle: `Title2-18Bd mt-[40px] text-center`,
  snsVideoSectionButton: `Body2-14Bd mt-[32px] flex flex-row justify-center gap-[16px]`,
}
